import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type StationFetchState = {
  nextFetchAtByStationId: Record<string, number>;
};

const initialState: StationFetchState = {
  nextFetchAtByStationId: {},
};

export const stationFetchSlice = createSlice({
  name: "stationFetch",
  initialState,
  reducers: {
    START_STATION_FETCH_TIMER: (
      state,
      action: PayloadAction<string>
    ) => {
      state.nextFetchAtByStationId[action.payload] = Date.now() + 20000;
    },

    RESET_STATION_FETCH_TIMER: (
      state,
      action: PayloadAction<string>
    ) => {
      state.nextFetchAtByStationId[action.payload] = Date.now() + 20000;
    },

    CLEAR_STATION_FETCH_TIMER: (
      state,
      action: PayloadAction<string>
    ) => {
      delete state.nextFetchAtByStationId[action.payload];
    },
  },
});

export const {
  START_STATION_FETCH_TIMER,
  RESET_STATION_FETCH_TIMER,
  CLEAR_STATION_FETCH_TIMER,
} = stationFetchSlice.actions;